import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[cwtWrapperContent]'
})
export class WrapperContentDirective {

  constructor(public ref: TemplateRef<any>) { }

}
